import { setLicenseKey as setLicenseKeyState, setClientPRO, setLicenseKeyError, setClientFree, removeLicenseKey } from "./actions";

import { requestInitialSettings } from "../api";
import { setInitialLoading, successInitialSettings } from "../initial";
import { receiveInitialSignals } from "../signals";
import { receiveInitialIndicators } from "../indicators";
import { getActiveSignalsType, initActiveSignalsType, setActiveSignalsType, updateTms } from "../client";
import { initDashboard } from "../dashboard";

export const setLicenseKey = (payload) => async (dispatch, getState) => {
  dispatch(setInitialLoading(true));
  dispatch(setLicenseKeyError(false));
  let setError = true;
  try {
    const { data } = await requestInitialSettings({ ...payload });

    const isValid = !!data?.account_info?.user_id;
    console.log("isValid", isValid);

    const availableSignalsCategory = data["available-signals-category"];

    dispatch(updateTms(data.tms));
    dispatch(receiveInitialSignals({ source: availableSignalsCategory[0].source, signals: data.signals }));
    dispatch(receiveInitialIndicators([...data.indicators]));
    dispatch(initDashboard([...data?.env_settings?.free_account_assets]));
    dispatch(setInitialLoading(false));

    const isPocketOptionAvailable = !!data.brokers_list_extended.find(
      (broker) => broker.code === "pocketoption"
    );
    const activeSignalsType = getActiveSignalsType(getState());

    if (activeSignalsType?.source.includes("otc") && !isPocketOptionAvailable) {
      dispatch(
        setActiveSignalsType({
          id: availableSignalsCategory[0].id,
          term: null,
          source: availableSignalsCategory[0].source,
        })
      );
    } else {
      dispatch(
        initActiveSignalsType({
          id: availableSignalsCategory[0].id,
          term: null,
          source: availableSignalsCategory[0].source,
        })
      );
    }

    if (isValid) {
      setError = false;
      dispatch(successInitialSettings(data));
      dispatch(setLicenseKeyState(data.lkey));

      if (data.account_info.license.toLowerCase() === "pro") {
        dispatch(setClientPRO());
      } else {
        dispatch(setClientFree());
      }
    }
  } catch (e) {
    console.log("Auth error");
  }

  if (setError) {
    dispatch(setLicenseKeyError(true));
    dispatch(setInitialLoading(false));
    setTimeout(() => {
      dispatch(setLicenseKeyError(false));
    }, 5000);
  }
};

export const removeLicenseKeyThunk = () => (dispatch) => {
  window.electron?.appLogout();
  dispatch(removeLicenseKey());
};
